import type { DashboardPanel as DashboardPanelType, DashboardSpec } from '@/dashboard/types';

/** Normalize a client DashboardSpec to the RPC shape (required panel sql + order). */
export function toRpcSpec(spec: DashboardSpec): {
  parameters: DashboardSpec['parameters'];
  panels: (Omit<DashboardPanelType, 'sql'> & { sql: string })[];
} {
  return {
    parameters: spec.parameters,
    panels: spec.panels.map((p) => ({ ...p, sql: p.sql ?? '', order: p.order ?? 0 })),
  };
}

export type RpcDashboardSpec = ReturnType<typeof toRpcSpec>;
